<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<ng-template elderToolbarColumn="center">
  <app-interval-context-menu></app-interval-context-menu>
</ng-template>

<elder-basic-pane-layout class="full">
  <elder-pane class="flex-none" appFacilityContext (facilityChange)="updateFacilityFilter($event)">
    <elder-pane-header>
      <elder-pane-title>{{ 'process.plans.title' | translate }}</elder-pane-title>
    </elder-pane-header>

    <elder-nav-list
      style="width: 300px; height: 100%"
      [value]="selectedPlan$ | async"
      [compareWith]="comparePlans"
      (valueChange)="updatePlanFilter($event)"
    >
      @for (plan of availablePlans$ | async; track plan) {
        <elder-nav-link [value]="plan">
          <span>{{ plan.name }}</span>
        </elder-nav-link>
      }
    </elder-nav-list>
  </elder-pane>
  <elder-pane>
    <elder-table class="flex" matSort [data]="data" [idField]="'number'">
      <!-- icon Column -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 10px"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>linear_scale</mat-icon>
        </td>
      </ng-container>

      <!-- segments Column -->
      <ng-container matColumnDef="segments">
        <th mat-header-cell *matHeaderCellDef style="width: 90%" mat-sort-header>
          {{ 'manufacturing.routes.title' | translate }}
        </th>
        <td mat-cell *matCellDef="let route">
          <app-production-route class="flex" [route]="route"></app-production-route>
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
